import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseDatatableCellComponent } from 'app/shared/components/table/components/table/base-datatable-cell.component';

@Component({
  selector: 'app-progress-bar-cell',
  template: `
    @if (show) {
      <app-progress-bar
        [value]="progressValue"
        [maxDays]="30"
        [reverseMode]="reverseMode"
        [color]="progressColor"
      />
      <span class="text-sm">{{ progressText }}</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarCellComponent extends BaseDatatableCellComponent {
  get reverseMode() {
    return this.colDef().custonConfig?.['getReverseMode']?.(this.rowData());
  }
  get progressValue() {
    return this.colDef().custonConfig?.['getProgressValue']?.(this.rowData());
  }
  get progressColor() {
    return this.colDef().custonConfig?.['getProgressColor']?.(this.rowData());
  }
  get progressText() {
    return this.colDef().custonConfig?.['getProgressText']?.(this.rowData());
  }
  get show() {
    const showFn = this.colDef().custonConfig?.['show'];
    const showIsUndefined = showFn === undefined;

    if (showIsUndefined) return true;

    return showFn?.(this.rowData());
  }
}
